export const apiUrl = process.env.REACT_APP_API_URL;

export const userRoles = [
    {
        label: 'کاربر حقیقی',
        value: 'PERSONAL',
    },
    {
        label: 'کاربر حقوقی',
        value: 'ORGANIZATIONAL',
    },
    {
        label: 'ادمین',
        value: 'ROLE_ADMIN',
    },
];

export const userStatuses = [
    {
        label: 'اولیه',
        value: 'INIT',
    },
    {
        label: 'ویرایش‌ شده',
        value: 'EDITED',
    },
    {
        label: 'تایید شده',
        value: 'CONFIRMED',
    },
    {
        label: 'رد شده',
        value: 'REJECTED',
    },
];

export const getUserStatusValue = (status) => {
    return userStatuses.find(item => item.value === status).label;
}

export const userAddressTypes = [
    {
        label: 'انبار',
        value: 'DEPOT',
    },
    {
        label: 'دفتر',
        value: 'OFFICE',
    },
];

export const getUserAddressValue = (address) => {
    const selectedAddress = userAddressTypes.find(item => item.value === address);
    return selectedAddress ? selectedAddress.label : '-';
}

export const userAddressStatuses = [
    {
        label: 'در حال بررسی',
        value: 'PENDING',
    },
    {
        label: 'تایید شده',
        value: 'CONFIRMED',
    },
    {
        label: 'رد شده',
        value: 'REJECTED',
    },
];

export const getUserAddressStatusLabel = (status) => {
    return userAddressStatuses.find(item => item.value === status).label;
}

export const userDocsType = {
    ID_CARD: 'کارت ملی',
    LICENSE: 'جواز کسب',
    NEWS_PAPER: 'روزنامه رسمی',
}

export const productShippingType = [
    {
        label: 'درب انبار',
        value: 'INVENTORY',
    },
    {
        label: 'تحویلی',
        value: 'DELIVERY',
    },
];

export const orderStatus = {
    CREATED: 'ثبت‌شده',
    VERIFIED_BY_SELLER: 'تایید توسط فروشنده',
    COMMISSION_SETTLEMENT: 'کارمزد بنک‌بازار پرداخت شد',
    PAID: 'پرداخت‌شده',
    PAID_CONFIRMED: 'تایید پرداخت',
    REPORTED: 'تخلف',
    SHIPPED: 'ارسال‌شده',
    SHIPPED_CONFIRMED: 'تایید ارسال',
    DELIVERED: 'تحویل‌شده',
    CANCELED: 'لغو‌شده',
}

export const productTypes = [
    {
        label: 'فروش قطعی',
        value: 'DEFINITE',
    },
    {
        label: 'پیش‌فروش',
        value: 'PREORDER',
    },
    {
        label: 'نامشخص',
        value: 'INDEFINITE',
    },
]

export const productStatuses = [
    {
        label: 'در حال بررسی',
        value: 'PENDING',
    },
    {
        label: 'ویرایش‌ شده',
        value: 'EDITED',
    },
    {
        label: 'تایید شده',
        value: 'CONFIRMED',
    },
    {
        label: 'رد شده',
        value: 'REJECTED',
    },
]

export const getProductStatusLabel = (status) => {
    return productStatuses.find(item => item.value === status).label;
}

export const fieldGroupTypes = [
    {
        label: 'متن',
        value: 'TEXT',
    },
    {
        label: 'فایل',
        value: 'MEDIA',
    },
    {
        label: 'دسته‌بندی',
        value: 'CATEGORY',
    },
    {
        label: 'برند',
        value: 'BRAND',
    },
    {
        label: 'محصول',
        value: 'PRODUCT',
    },
]

export const eventTypes = {
    UserCreated: 'ایجاد کاربر',
    UserUpdated: 'بروزرسانی کاربر',
    OrderCreated: 'سفارش جدید',
    OrderAddressChanged: 'تغییر آدرس سفارش',
    OrderStatusChanged: 'تغییر وضعیت سفارش',
    ProductCreated: 'ایجاد محصول',
    ProductUpdated: 'بروزرسانی محصول',
    ProductStatusChanged: 'تغییر وضعیت محصول',
    AddressCreated: 'ایجاد آدرس',
    AddressStatusChanged: 'تغییر وضعیت آدرس',
    TokenGenerated: 'ورود کاربر',
    TokenRefreshed: 'تازه سازی توکن کاربر',
}

export const configTypes = [
    {
        label: 'متن',
        value: 'text',
    },
    {
        label: 'HTML',
        value: 'html',
    },
]
